"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LasError = function LasError(message) {
  _classCallCheck(this, LasError);

  this.name = 'LasError';
  this.message = message;
};

exports.LasError = LasError;

var ColumnError = function ColumnError(column) {
  _classCallCheck(this, ColumnError);

  this.name = 'ColumnError';
  this.message = "Column ".concat(column, " doesn't exist in the file");
};

exports.ColumnError = ColumnError;

var PathError = function PathError() {
  _classCallCheck(this, PathError);

  this.name = 'PathError';
  this.message = 'Path is invalid';
};

exports.PathError = PathError;

var CsvError = function CsvError() {
  _classCallCheck(this, CsvError);

  this.name = 'CsvError';
  this.message = "Couldn't convert file to CSV";
};

exports.CsvError = CsvError;

var PropertyError = function PropertyError(property) {
  _classCallCheck(this, PropertyError);

  this.name = 'PropertyError';
  this.message = "Property ".concat(property, " doesn't exist");
};

exports.PropertyError = PropertyError;